// import '../css/style.scss'
import { ua } from './modules/ua'
import { realTimeTable } from './modules/realtime'
import inView from 'in-view'
import Swiper from 'swiper/bundle'
import smoothscroll from 'smoothscroll-polyfill'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)

    window.addEventListener('load', () => {
      document.querySelector('.loader').classList.add(klass.hidden)
      this.setFillHeight()
      this.setViewMode()
    })

    // ナビゲーション開閉
    document.querySelector('.nav-trigger').addEventListener('click', () => {
      document.querySelector('body').classList.toggle(klass.nav)
    })

    // ナビゲーションを押下時に閉じる
    Array.from(document.querySelectorAll('.gNav a')).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.querySelector('body').classList.toggle(klass.nav)
      })
    })

    inView('.inview').on('enter', (el) => {
      el.classList.add('is-view')
    })
    inView.offset(100)

    /**
     * CSS変数 --vh セット
     * ※画面横幅が変わった場合のみ動作
     */
    let vw = window.innerWidth
    window.addEventListener('resize', () => {
      this.setViewMode()
      if (vw === window.innerWidth) {
        return
      }
      vw = window.innerWidth
      this.setFillHeight()
    })

    const pageTop = document.querySelector('.pagetop')
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        document.querySelector('body').classList.add('is-scroll')
      } else {
        document.querySelector('body').classList.remove('is-scroll')
      }

      if (window.scrollY > 100) {
        pageTop.classList.add(klass.active)
      } else {
        pageTop.classList.remove(klass.active)
      }
    })

    // トップページのみ適用
    if (this.body.classList.contains('page-index')) {
      this.swiper = new Swiper('.news-slide', {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3,
        centeredSlides: false,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })

      realTimeTable()
    }

    if (this.body.classList.contains('page-guideline')) {
      const selectGuide = document.querySelector('[name="selectGuide"]')
      selectGuide.addEventListener('change', (e) => {
        e.preventDefault()

        const targetId = e.target.value
        const targetElement = document.querySelector(targetId)
        const rectTop = targetElement.getBoundingClientRect().top
        const offsetTop = window.pageYOffset
        const top = rectTop + offsetTop
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      })
    }

    const videoTrigger = document.querySelectorAll('.videoTrigger')
    const videoCloseTrigger = document.querySelectorAll('.modal-close')
    if (videoTrigger.length > 0) {
      Array.from(videoTrigger).forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault()
          const youtubeID = e.target.getAttribute('data-id')
          const parm = youtubeID === 'i9APcGukDKY' ? '&start=180' : ''

          document.querySelector('.modalMovie .message-body').innerHTML =
            '<figire class="video-container"><iframe width="960" height="500" src="https://www.youtube.com/embed/' +
            youtubeID +
            '?rel=0&autoplay=true' +
            parm +
            '" frameborder="0" allowfullscreen></iframe></figire>'
          document.querySelector('.modalMovie').classList.add('is-active')
        })
      })
      Array.from(videoCloseTrigger).forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault()
          document.querySelector('.modalMovie .message-body').innerHTML = ''
          document.querySelector('.modalMovie').classList.remove('is-active')
        })
      })
    }

    // Timetableページのみ適用
    if (this.body.classList.contains('page-timetable')) {
      const ttTab = document.querySelectorAll('.timeTableDay')
      const ttImg = document.querySelectorAll('.timeTableImg')
      if (ttTab.length > 0) {
        Array.from(ttTab).forEach((trigger, n, t) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault()
            Array.from(ttTab).forEach((tab) => {
              tab.classList.remove(klass.selected)
            })
            Array.from(ttImg).forEach((img) => {
              img.classList.remove(klass.selected)
            })

            trigger.classList.add(klass.selected)
            document.querySelector(trigger.getAttribute('data-id')).classList.add(klass.selected)
          })
        })
      }

      const largeButton = document.querySelector('.timeTableLargeButton button')
      largeButton.addEventListener('click', (e) => {
        e.preventDefault()
        var _this = largeButton
        _this.classList.toggle(klass.large)

        document.querySelector('.timeTableArea').classList.toggle(klass.large)
        if (_this.classList.contains(klass.large)) {
          _this.innerHTML = '<span>タイムテーブルを元に戻す</span>'
        } else {
          _this.innerHTML = '<span>タイムテーブルを大きくする</span>'
        }
      })
    }

    // Goodsページのみ適用
    if (this.body.classList.contains('page-goods')) {
      const largeButton = document.querySelector('#goodsList .biggerButton')
      largeButton.addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector('#goodsList').classList.toggle(klass.active)
      })
    }
  }

  /**
   * CSS変数設定 画面高さの取得からvhを設定
   * ※iosの設定向け
   */
  setFillHeight() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  /**
   * 表示モード指定
   */
  setViewMode() {
    const mode = window.innerWidth < window.innerHeight ? 'is-landscape' : 'is-portrait'
    document.querySelector('body').classList.add(mode)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.sc22 = new App()

  smoothscroll.polyfill()
  Array.from(document.querySelectorAll('.js-smooth-scroll')).forEach((link) => {
    link.addEventListener('click', (e) => {
      const ankerTarget = e.target
      e.preventDefault()

      document.querySelector('body').classList.remove('view-nav')

      const targetId = ankerTarget.hash || link.getAttribute('href')
      const targetElement = document.querySelector(targetId)
      const rectTop = targetElement.getBoundingClientRect().top
      const offsetTop = window.pageYOffset
      const buffer = document.querySelector('.header').clientHeight + 20
      const top = rectTop + offsetTop - buffer
      window.scrollTo({
        top,
        behavior: 'smooth',
      })
    })
  })
})
